// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { theme } from '../../assets/styles/theme';
import media from 'assets/styles/query';
import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`;

export const Hero = styled.div`
  padding-top: ${theme.headerHeight};
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  ${media.lessThan('medium')`
    height: 80vh;

    img {
      width: 100%;
    }
  `}

  ${media.lessThan('small')`
    height: 50vh;

    img {
      width: 100%;
    }
  `}
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;

  img {
    width: 100%;

    grid-area: 1 / 1 / 2 / 2;

    &:nth-child(1) {
      grid-area: 1 / 2 / 2 / 3;
    }
  }

  ${media.lessThan('medium')`
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 1fr);

    img {
      grid-area: 1 / 1 / 2 / 2;

      &:nth-child(1) {
        grid-area: 2 / 1 / 3 / 2;
      }
    }
  `}
`;

export const HorizontalBig = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  img {
    width: 100%;
  }
`;

export const HorizontalSmall = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 20vh;

  ${media.lessThan('small')`

    img {
      width: 100%;
    }
  `}
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -2px;

  width: 100%;
  height: 15vh;

  background: #dbe7f2;
`;

export const StyledButton = styled.button`
  border-radius: 12px;
  border: 2px solid #000;
  background-color: transparent;
  padding: 4px 24px;
  transition: 0.3s ease-in-out;

  color: #000;
  font-family: 'SF Pro Display';
  font-size: 18.087px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.362px;

  &:hover {
    background-color: #000;
    color: #fff;
  }

  &:active {
    transform: scale(0.98);
  }
`;
